import React from 'react';
import Title from '../views/title/index';
import Bottom from '../views/bottom/index';

function Views({left, right, children, title}) {
  return (
    <>
      <Title title={title} />
      {children}
      <Bottom left={left} right={right} />
    </>
  );
}

export default Views;
